import {
  Box,
  Stack
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const CategoriesStack = styled(Stack)<{ $isHome: boolean }>(({ theme, $isHome }) => ({
  [theme.breakpoints.down("sm")]: {
    marginTop: $isHome ? "-8px" : "0"
  }
}));

export const CategoryWrapper = styled(Box)(() => ({
  alignItems: "center",
  borderRadius: "4px",
  display: "flex",
  flexDirection: "row",
  gap: "7px",
  height: "fit-content",
  marginBottom: "8px",
  marginRight: "8px",
  maxWidth: "calc(50% - 8px)",
  padding: "8px"
}));

export const CategoryDot = styled(Box)(({ theme }) => ({
  backgroundColor: theme.customColors.accentVariantA,
  borderRadius: "999px",
  height: "7px",
  width: "7px"
}));

export const CategoryText = styled(Box)(({ theme }) => ({
  "-webkit-box-orient": "vertical",
  "-webkit-line-clamp": "1",
  color: theme.customColors.textPrimary,
  display: "-webkit-box",
  fontSize: "0.75rem",
  fontWeight: 700,
  height: "fit-content",
  lineHeight: 1.2,
  overflow: "hidden",
  overflowWrap: "break-word",
  textOverflow: "ellipsis",
  textTransform: "uppercase"
}));
